import api from './api'

const invoiceDataProvider = {
  getCompanies(params = {}) {
    return api.query('Company/api/Company/GetAllCompanies', {
      params,
    })
  },
  getAgents(params = {}) {
    return api.query('Company/api/Company/GetCompanyAllAgents', {
      params,
    })
  },
  addPeaple(person) {
    return api.post('People/api/People', person)
  },
  addInvoice(invoiceData) {
    return api.post('Invoice/api/Invoice/CreateInvoice', invoiceData)
  },
  getCustomer(params = {}) {
    return api.query('People/api/People', {
      params,
    })
  },
  getInvoiceDetails(params = {}) {
    return api.query('Invoice/api/Invoice/GetInvoiceById', { params })
  },
  invoicePrint(params = {}) {
    return api.query('Invoice/api/Invoice/InvoiceForPrint', { params })
  },
  getAllCompanies(params = {}) {
    return api.query('Company/api/Company/GetAllCompanies', { params })
  },
  createCompany(company) {
    return api.post('Company/api/Company/CreateCompany', company)
  },
  getProducts(params = {}) {
    return api.query('Product/api/Product/SearchProduct', { params })
  },
  getProductDetail(params = {}) {
    return api.query('Product/api/Product/AdvancedSearchV2', {
      params,
    })
  },
  getProductPrice(params = {}) {
    return api.query('Product/api/Product/GetProductPrice', {
      params,
    })
  },
  addProduct(data) {
    return api.post('Product/api/Product/AddProduct', data)
  },
  getProvince(params = {}) {
    return api.query('Region/api/City/GetAllProvinces', { params })
  },
  getCity(params = {}) {
    return api.query('Region/api/City/GetProvinceAllCities', { params })
  },
  getInvoiceDataWithId(params = {}) {
    return api.query('Invoice/api/Invoice/GetInvoiceByIdWithDataTable', { params })
  },
  deletePeople(params = {}) {
    return api.delete('People/api/People/DeletePeople', { params })
  },
  deactivePeople(params) {
    return api.put('People/api/People/DeactivatePeople', params)
  },
  updatePeople(params) {
    return api.put('People/api/People/BaseUpdatePeople', params)
  },
  editInvoice(data) {
    return api.put('Invoice/api/Invoice/EditInvoice', data)
  }
}

export default invoiceDataProvider
